import React from "react";
import Link from "gatsby-link";
import Icon from "../Icon";

const ButtonBackEvents = ({}) => {
  return (
    <Link
      to="/our-events/"
      className="button--back-events flex absolute left-0 bg-dark pa1 o-60"
    >
      <Icon
        path="arrow-left"
        className="button--back-events__arrow flex items-center h-100 pr1"
      />
      <p className="white h-6 ttu">Events</p>
    </Link>
  );
};

export default ButtonBackEvents;



// WEBPACK FOOTER //
// ./src/components/Buttons/ButtonBackEvents.js